// IdTokenClaims.js
import React from "react";

const IdTokenClaims = () => {
  if (process.env.NODE_ENV !== "development") {
    return null;
  }

  return <div>ID token claims are only available in development mode.</div>;
};

export default IdTokenClaims;
